import "jquery/dist/jquery.slim.min";
import $ from "jquery";
import "popper.js";
import "bootstrap/js/dist/modal.js";
import "bootstrap/js/dist/tooltip.js";
import "bootstrap/js/dist/collapse.js";
import "bootstrap/js/dist/dropdown.js";
import "slick-slider";
import AOS from "aos";
import "animsition/dist/js/animsition";

$(document).ready(function () {
	/* let current = window.location.pathname;
	if (current !== '/') {
		document.getElementsByTagName('body').classList.add("animsition")
	} else {
		//console.log("is homepage")
	} */

	autoPlayYouTubeModal();
});

AOS.init({
	startEvent: "DOMContentLoaded",
	initClassName: "aos-init", // class applied after initialization
	animatedClassName: "aos-animate", // class applied on animation
	anchorPlacement: "top-bottom",
	easing: "ease-in-out-sine",
	duration: 800,
	once: false,
});

// places to visit slider
$(".places-to-visit").slick({
	infinite: true,
	speed: 300,
	slidesToShow: 1,
	centerMode: true,
	variableWidth: true,
	mobileFirst: true,
	dots: true,
	centerPadding: "0",
	responsive: [
		{
			breakpoint: 1067,
			settings: {
				slidesToShow: 1,
				slidesToScroll: 1,
				infinite: true,
				dots: false,
				centerPadding: "50px",
				fade: false,
				centerMode: false,
			},
		},
	],
});

// tour slider
// places to visit slider
$(".tour-slider").slick({
	infinite: true,
	speed: 1200,
	slidesToShow: 1,
	centerMode: true,
	variableWidth: false,
	fade: true,
	dots: false,
	centerPadding: "0",
	arrows: false,
	autoplay: true,
	autoplaySpeed: 2500,
	draggable: false,
	pauseOnFocus: false,
	pauseOnHover: false,
});

$(".animsition").animsition({
	inClass: "fade-in",
	outClass: "fade-out",
	inDuration: 400,
	outDuration: 400,
	linkElement: ".animsition-link",
	// e.g. linkElement: 'a:not([target="_blank"]):not([href^="#"])'
	loading: true,
	loadingParentElement: "body", //animsition wrapper element
	loadingClass: "animsition-loading",
	loadingInner: "", // e.g '<img src="loading.svg" />'
	timeout: false,
	timeoutCountdown: 5000,
	onLoadEvent: true,
	browser: ["animation-duration", "-webkit-animation-duration"],
	// "browser" option allows you to disable the "animsition" in case the css property in the array is not supported by your browser.
	// The default setting is to disable the "animsition" in a browser that does not support "animation-duration".
	overlay: false,
	overlayClass: "animsition-overlay-slide",
	overlayParentElement: "body",
	transition: function (url) {
		window.location.href = url;
	},
});

$("select#Country").change(function () {
	var selectedCountry = $(this).children("option:selected").val();
	if (selectedCountry == "New Zealand") {
		$(".selected-newzealand").show();
		$(".selected-australia").hide();
	} else {
		$(".selected-newzealand").hide();
		$(".selected-australia").show();
	}
});

$("input.input-validation-error").on("input", function () {
	$(this).removeClass("input-validation-error");
});

//FUNCTION TO GET AND AUTO PLAY YOUTUBE VIDEO FROM DATATAG
function autoPlayYouTubeModal() {
	var trigger = $("body").find('[data-target="#videoModal"]');
	trigger.click(function () {
		var theModal = $(this).data("target"),
			videoSRC = $(this).attr("data-theVideo"),
			videoSRCauto = videoSRC + "?autoplay=1;rel=0";
		$(theModal + " iframe").attr("src", videoSRCauto);
		$(theModal + " button.icon-cross").click(function () {
			$(theModal + " iframe").attr("src", videoSRC);
		});
		$(theModal).click(function () {
			$(theModal + " iframe").attr("src", videoSRC);
		});
	});
}
